import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const MAX_ONE_DECIMAL = /^\d+(\.\d)?$/;

export function maxOneDecimal(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    return MAX_ONE_DECIMAL.test(String(value)) ? null : { maxOneDecimal: true };
  };
}
